import { jsx as _jsx } from "react/jsx-runtime";
import { Menu } from "@mui/material";
import { forwardRef } from "react";
export const UiMenu = forwardRef((props, ref) => (_jsx(Menu, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_menu.js.map